import type { NavLinkProps, NavSubsection } from '@/types';

const getLinkProperties = (link: HTMLAnchorElement | null) => {
  if (!link) {
    return undefined;
  }

  const { attributes, textContent } = link;
  const href = attributes.getNamedItem('href')?.nodeValue ?? '';
  const target = attributes.getNamedItem('target')?.nodeValue;

  return {
    href,
    ...(target ? { target } : {}),
    textContent: textContent ?? '',
  };
};

const getSubmenu = (item: Element) => {
  const subSections = item.querySelectorAll(
    '.navigation__secondary__links-wrapper',
  );

  return Array.from(subSections.values()).map((section: Element) => {
    const subsectionItem: NavSubsection = {
      heading: { href: '', textContent: '' },
      isFeatured: false,
      links: [],
    };

    const heading = section.querySelector(
      '.navigation__secondary__section__title',
    );

    if (heading) {
      const headingLink: HTMLAnchorElement | null = heading.querySelector(
        '.navigation__secondary__section__link',
      );

      const headingProps = getLinkProperties(headingLink);

      if (headingProps) {
        subsectionItem.heading = headingProps;
      } else {
        subsectionItem.heading = {
          href: '',
          textContent: heading.textContent ?? '',
        };
      }
    }

    subsectionItem.isFeatured = Boolean(
      section.parentElement?.classList.contains(
        'navigation__secondary__section--featured',
      ),
    );

    const subsectionLinks: NodeListOf<HTMLAnchorElement> =
      section.querySelectorAll(
        '.navigation__secondary__list__item > .navigation__secondary__section__link',
      );

    subsectionItem.links = Array.from(subsectionLinks)
      .map(link => getLinkProperties(link))
      .filter(link => typeof link !== 'undefined');

    return subsectionItem;
  });
};

export const getLinksDataFromNodeList = (nodes: NodeListOf<Element>) =>
  Array.from(nodes)
    .map(item => {
      const itemData: NavLinkProps | undefined = getLinkProperties(
        item.querySelector('a'),
      );

      // #2947 The desktop Razor partial is the single source of this flag; the mobile menu
      // reads it back off the rendered list item rather than fetching the menu again.
      if (
        itemData &&
        item.classList.contains('navigation__list__item--highlighted')
      ) {
        // Christmas red is the default both here and in MenuService, so anything that is not
        // explicitly the Black Friday variant renders red.
        itemData.highlightColour = item.classList.contains(
          'navigation__list__item--highlight-black-friday',
        )
          ? 'black-friday'
          : 'christmas-red';
      }

      if (item.classList.contains('has-submenu')) {
        const submenu = getSubmenu(item);

        if (itemData) {
          itemData.submenu = submenu;
        }
      }

      return itemData;
    })
    .filter(item => typeof item !== 'undefined');
